import { render } from "./Index.vue?vue&type=template&id=94497d68&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=94497d68&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94497d68"]])

export default __exports__